import { ROOT } from '../routes'
import { type OnboardingFlowConfigItem } from './onboarding-config.types'
import { SHARED_KYC_FLOW_CONFIG_ITEMS } from './onboarding-config-kyc'

export const ONBOARDING_INDIVIDUAL_NO_ABN_FLOW_CONFIG_ITEMS_COMMON: OnboardingFlowConfigItem[] =
  [
    ...SHARED_KYC_FLOW_CONFIG_ITEMS,
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.ABOUT_BUSINESS.path,
      isCheckpoint: true,
    },
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.BUSINESS_REGULATIONS.path,
      isCheckpoint: false,
    },
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.UPLOAD_BANK_STATEMENTS.path,
      isCheckpoint: true,
    },
    {
      path: ROOT.ONBOARDING.PRE_ONBOARDED_QUESTIONNAIRE.path,
      isCheckpoint: true,
    },
    {
      path: ROOT.ONBOARDING.COMPLETE.path,
      isCheckpoint: true,
    },
  ]

export const ONBOARDING_INDIVIDUAL_NO_ABN_FLOW_CONFIG_ITEMS: OnboardingFlowConfigItem[] =
  [
    {
      path: ROOT.ONBOARDING.path,
      isCheckpoint: false,
    },
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.path,
      isCheckpoint: false,
    },
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.TRADING_NAME.path,
      isCheckpoint: true,
    },
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.PRINCIPAL_PLACE_OF_BUSINESS.path,
      isCheckpoint: true,
    },
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.REVENUE.path,
      isCheckpoint: false,
    },
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.BUSINESS_TYPE.path,
      isCheckpoint: false,
    },
    ...ONBOARDING_INDIVIDUAL_NO_ABN_FLOW_CONFIG_ITEMS_COMMON,
  ]

export const ONBOARDING_INDIVIDUAL_NO_ABN_FLOW_CONFIG_ITEMS_PHASE_1: OnboardingFlowConfigItem[] =
  [
    {
      path: ROOT.ONBOARDING.path,
      isCheckpoint: false,
    },
    {
      path: ROOT.ONBOARDING.INDIVIDUAL_NO_ABN.YOUR_BUSINESS_INFORMATION.path,
      isCheckpoint: false,
    },

    ...ONBOARDING_INDIVIDUAL_NO_ABN_FLOW_CONFIG_ITEMS_COMMON,
  ]

export const ONBOARDING_INDIVIDUAL_NO_ABN_FLOW_CONFIG_ITEMS_PHASE_2: OnboardingFlowConfigItem[] =
  [
    {
      path: ROOT.ONBOARDING.YOUR_BUSINESS_INFORMATION.path,
      isCheckpoint: false,
    },

    ...ONBOARDING_INDIVIDUAL_NO_ABN_FLOW_CONFIG_ITEMS_COMMON,
  ]
